module.exports = __webpack_public_path__ + "img/maple.297565a.svg";